import { toast } from 'react-toastify'

import { base_url } from './constants'

export const handleCopy = async (value: string, type?: 'link' | 'value' | '', message?: string) => {
  let copyVal = value
  if (type === 'link') {
    copyVal = new URL(value, base_url).href
  }
  await navigator.clipboard.writeText(copyVal)
  toast.success(message || 'Link copied to clipboard!')
}
